export enum SalesChannel {
  WEB_ORDERING = "webordering",
  WIDGET = "widget",
  TIKTOK = "tiktok",
  WHATSAPP = "whatsapp",
  GOOGLE = "google",
  MESSENGER = "messenger",
  INSTAGRAM = "instagram",
  FACEBOOK = "facebook",
  WEBSITE = "website",
  GOOGLE_MY_BUSINESS = "googlemybusiness",
  MOBILE_APP = "mobileapp",
  CATERING = "catering",
}

export type IDomainSalesChannel = `${SalesChannel}`;
